import PropTypes from 'prop-types';
import React from 'react';
import ReactDOM from 'react-dom';

export default class ScrollIntoViewElement extends React.Component {
    componentWillReceiveProps(nextProps) {
        if (
            this.props.isEnabled &&
            this.props.scrollingTrigger &&
            nextProps.scrollingTrigger &&
            this.isOutOfView(this.props.scrollingContainer, ReactDOM.findDOMNode(this))
        ) {
            this.scroll();
        }
    }

    componentDidMount() {
        if (
            this.props.canScrollOnMount &&
            this.isOutOfView(this.props.scrollingContainer, ReactDOM.findDOMNode(this))
        ) {
            this.scroll();
        }
    }

    isOutOfView(container, element) {
        var $element = $(element);
        var $container = $(container);
        var elementTop = $element.offset() ? $element.offset().top : 0;
        var containerTop = $container.offset() ? $container.offset().top : 0;
        var containerHeight = $container.height();
        var containerScroll = $container.scrollTop();
        var viewportTop = $(window).scrollTop();
        var viewportHeight = $(window).height();
        var isUnderContainer = elementTop > containerTop + containerHeight + containerScroll;
        var isAboveContainer = elementTop < containerTop;
        var isOutOfViewport = elementTop < viewportTop || elementTop > viewportTop + viewportHeight;

        return isUnderContainer || isAboveContainer || isOutOfViewport;
    }

    scroll() {
        ReactDOM.findDOMNode(this).scrollIntoView(true);
    }

    render() {
        return this.props.children;
    }
}

ScrollIntoViewElement.propTypes = {
    isEnabled: PropTypes.bool,
    scrollingTrigger: PropTypes.any,
    scrollingContainer: PropTypes.object,
    canScrollOnMount: PropTypes.bool,
};

ScrollIntoViewElement.defaultProps = {
    isEnabled: true,
    canScrollOnMount: false,
    scrollingContainer: window,
};



// WEBPACK FOOTER //
// ./~/@99designs/react-components/components/ScrollIntoViewElement.jsx